import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Clock } from 'lucide-react';

interface PendingProfileRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  requestType?: 'create' | 'edit';
}

const PendingProfileRequestModal = ({ 
  isOpen, 
  onClose, 
  requestType = 'edit' 
}: PendingProfileRequestModalProps) => {
  const isCreateRequest = requestType === 'create';
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-orange-100">
            <AlertTriangle className="h-6 w-6 text-orange-600" />
          </div>
          <DialogTitle className="text-lg font-semibold">
            {isCreateRequest ? 'Profile Creation Pending' : 'Profile Update Pending'}
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground space-y-3 text-left mt-4">
            <div className="flex items-start space-x-3">
              <Clock className="h-4 w-4 text-orange-500 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-foreground mb-1">
                  {isCreateRequest 
                    ? 'Your profile creation request is under review' 
                    : 'You have a profile update request pending approval'
                  }
                </p>
                <p>
                  {isCreateRequest
                    ? 'Please wait for admin approval before creating your profile. You cannot submit additional requests until this one is processed.'
                    : 'Please wait for admin approval before making additional changes. You cannot submit new updates until your current request is processed.'
                  }
                </p>
              </div>
            </div>
            <div className="bg-blue-50 p-3 rounded-md">
              <p className="text-sm font-medium text-blue-800 mb-1">What happens next?</p>
              <p className="text-sm text-blue-700">
                An administrator will review your request and either approve or provide feedback. 
                You'll receive a notification once the review is complete.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-6">
          <Button onClick={onClose} className="w-full sm:w-auto">
            I Understand
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PendingProfileRequestModal;